import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_ScanHistory } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-scan-history-view-details",
	templateUrl: "./scan-history-view-details.component.html",
	styleUrls: ["./scan-history-view-details.component.css"],
})
export class ScanHistoryViewDetailsComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig, private ScanHistoryService: DataService_ScanHistory) {}

	ngOnInit(): void {
		//Main
		this.ScanID = this.dialogConfig.data.ScanID;

		this.loadScan();
	}

	////////////////////////////////////
	// Data
	////////////////////////////////////
	ScanID: any;

	StationModeID: any = 0;
	StationMode: any = "";
	ResultDesc: any = "";
	ScanStation: any = "";
	FacilityDesc: any = "";
	LocationDesc: any = "";
	LogDTDesc: any = "";
	ScanDateDesc: any = "";
	PersonName: any = "";

	//Entry
	//Exit
	ReleaseType: any = "";

	//Meal
	MealName: any = "";
	MealSubsidyTypeDesc: any = "";

	//Access
	CourseType: any = "";
	Section: any = "";
	RoomNo: any = "";

	//Time Stamp
	TimeScanType: any = "";

	//Event
	EventName: any = "";

	//Manual
	ManualDesc: any = "No";
	IDStatus: any = "";
	ReprintCard: any = "";
	PrintedTempCard: any = "";
	ChargedReprintFee: any = "";
	ChargedTempFee: any = "";
	PaidAmount: any = "";
	ReprintFee: any = "";
	TempIDFee: any = "";
	Comments: any = "";

	ScanData: any;

	////////////////////////////////////

	////////////////////////////////////
	// Load Data
	////////////////////////////////////

	loadScan() {
		var result = this.ScanHistoryService.ScanSelect(this.ScanID);
		result.subscribe(
			(response) => {
				this.ScanData = response[0];

				this.UpdateData();
			},
			(error) => {}
		);
	}

	UpdateData() {
		this.StationModeID = this.ScanData.StationModeID;
		this.StationMode = this.ScanData.StationModeDesc;
		this.ResultDesc = this.ScanData.ResultDesc;
		this.ScanStation = this.ScanData.ScanStation;
		this.FacilityDesc = this.ScanData.FacilityName;
		this.LocationDesc = this.ScanData.FacilityLocationName;
		this.LogDTDesc = moment(new Date(this.ScanData.LogDT)).format("MM/DD/YYYY h:mm:ss a");
		this.ScanDateDesc = moment(new Date(this.ScanData.ScanDT)).format("MM/DD/YYYY h:mm:ss a");
		this.PersonName = this.ScanData.PersonName;

		//Entry
		//Exit
		this.ReleaseType = this.ScanData.ReleaseType;

		//Meal
		this.MealName = this.ScanData.MealName;
		this.MealSubsidyTypeDesc = this.ScanData.MealSubsidyTypeDesc;

		//Access
		this.CourseType = this.ScanData.CourseTypeDesc;
		this.Section = this.ScanData.Section;
		this.RoomNo = this.ScanData.RoomNo;

		//Time Stamp
		this.TimeScanType = this.ScanData.TimeScanTypeDesc;

		//Event
		this.EventName = this.ScanData.EventDescShort;

		//Manual
		this.ManualDesc = this.ScanData.ManualDesc;
		this.IDStatus = this.ScanData.IDStatusDesc;
		if (this.IDStatus == "") {
			this.IDStatus = "No ID Card in Database";
		}

		this.ReprintCard = this.ScanData.ReprintCardInd == 1 ? "Yes" : "No";
		this.PrintedTempCard = this.ScanData.PrintedTempInd == 1 ? "Yes" : "No";
		this.ChargedReprintFee = this.ScanData.ChargeReprintFeeInd == 1 ? "Yes" : "No";
		this.ChargedTempFee = this.ScanData.ChargedTempFeeInd == 1 ? "Yes" : "No";
		this.PaidAmount = this.ScanData.PaidAmount;
		this.ReprintFee = this.ScanData.ReprintFee;
		this.TempIDFee = this.ScanData.TempIDFee;
		this.Comments = this.ScanData.ManualComment;
	}

	////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////
	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////

	////////////////////////////////////
	// Helpers
	////////////////////////////////////
	IsManual() {
		return this.ManualDesc != "No";
	}
	////////////////////////////////////
}
